module.exports = __webpack_public_path__ + "static/media/8.04dd3550.png";